export const StripeType = {
    nothing: 'N',
    red: 'V',
    black: 'P',
}